<template>
  <div class="fork-preview">
    <el-form
      ref="form"
      class="search-form"
      label-width="80px"
    >
      <el-tabs
        v-model="tab"
        stretch
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          label="当前课程"
          name="current"
        >
          <el-form-item label="教材">
            <el-input
              v-model="textbookName"
              disabled
            />
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane
          label="其他课程"
          name="other"
        >
          <textbook-category-select @change="selectLevels" />

          <el-form-item label="教材">
            <el-cascader
              clearable
              filterable
              style="width: 80%;"
              :props="levelsSelectionProps"
              :options="tabOther.levels"
              @change="selectTextbooks"
            >
              <template slot-scope="{ node, data }">
                <span style="float: left">{{ data.name }}</span>
                <span
                  v-if="data.isUsed === 0"
                  style="float: right; color: #8492a6; font-size: 13p"
                >（{{ $t("禁用") }}）</span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>

      <el-form-item>
        <el-button
          type="primary"
          size="small"
          @click="save()"
        >
          确定
        </el-button>
        <el-button
          size="small"
          @click="$emit('close')"
        >
          取消
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const debug = require('debug')('ccs:component:fork-preview');
import textbookCategorySelect from './textbook_category_select';
import axios from 'axios';
import { version } from 'punycode';

export default {
	components: {
		textbookCategorySelect
	},
	props: {
		courseId: [Number, String],
		version: Number,
		isReview: Boolean
	},
	data() {
		return {
			levelsSelectionProps: {
				lazy: true,
				value: 'id',
				label: 'name',
				expandTrigger: 'hover',
				lazyLoad(node, resolve) {
					if (node.value) {
						const { value: textbookId, level } = node;
						axios
							.get(`/api/textbooks/${textbookId}/child`, {
								params: {
									fields: 'id,name,nameEnUs,nameZhCn,isUsed'
								}
							})
							.then(textbooks => {
								// 判断级别
								textbooks.forEach(textbook => (textbook.leaf = level + 1 >= 3));
								resolve(textbooks);
							})
							.catch(() => resolve());
					} else {
						resolve();
					}
				}
			},

			//   选择的tab页码
			tab: 'current',

			tabCurrent: {
				level: null,
				course: null,
				courseId: null
			},

			tabOther: {
				levels: [],
				courseId: null
			},
			preview: null
		};
	},
	computed: {
		// 计算属性的 getter
		textbookName: function() {
			if (this.tabCurrent.course) {
				return this.tabCurrent.course.name;
			} else {
				return '';
			}
		},

		selectCourseId: function() {
			if (this.tab === 'current') {
				return this.tabCurrent.courseId;
			} else if (this.tab === 'other') {
				return this.tabOther.courseId;
			} else {
				return null;
			}
		}
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			debug('[init] lessonId: %s, version: %s', this.courseId, this.version);
			let url='';
			this.isReview?url=`/api/review/${this.courseId}`:url=`/api/preview/${this.courseId}`;
			const [course, preview] = await Promise.all([
				axios.get(`/api/textbooks/${this.courseId}`, {
					params: {
						fields: 'id,name,isUsed'
					}
				}),
				axios.get(url, {
					params: { version: this.version }
				})
			]);

			this.tabCurrent.course = course;
			this.tabCurrent.courseId = this.courseId;
			this.preview = preview;
		},

		async selectLevels(levels) {
			this.tabOther.courseId = null;

			this.tabOther.levels = levels;
		},

		selectTextbooks([levelId, unitId, courseId]) {
			debug('[selectTextbooks] levelId: %s, unitId: %s, courseId: %s', levelId, unitId, courseId);
			this.tabOther.courseId = courseId;
		},

		async save() {
			debug('[save] from: %s, to: %s', this.courseId, this.selectCourseId);
			if (!this.selectCourseId) {
				this.$message({
					showClose: true,
					message: '请选择要复制到的课程。',
					type: 'error'
				});
				return;
			}
			let url='';
			this.isReview?url=`/api/review/${this.selectCourseId}`:url=`/api/preview/${this.selectCourseId}`;
			await axios.post(url, {
				action: 'save',
				name: this.preview.name,
				describe: `forked from ${this.preview.name} ${this.courseId} v${
					this.version
				}`,
				devices: this.preview.devices,
				questions: this.preview.questions.map(({ question }) => {
					return {
						uuid: question.uuid,
						type: question.type
					};
				})
			});
			this.$emit('close', this.selectCourseId);
		}
	}
};
</script>
